// extracted by mini-css-extract-plugin
export default {"title":"UpdSuccessDownload_title__xTyd1","description":"UpdSuccessDownload_description__931l7"};